var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iq-pricing text-center"},[_c('ParallaxStyle1',{attrs:{"bg-image":_vm.bgImage,"class-names":"price-title iq-parallax iq-over-blue-80"}},[_vm._t("cardHeader")],2),_vm._v(" "),_vm._t("cardList"),_vm._v(" "),_c('div',{staticClass:"price-footer"},[_vm._t("cardFooter")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }